import React, { Component } from 'react';

import './styles.css';

/**
 * Creates an anchor with an offset of 76px.
 *
 * @augments {Component}
 */
export default class HashAnchor extends Component {

	render () {
		return (
			<span className='HashAnchor'>
				<span {...this.props} />
			</span>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/HashAnchor/HashAnchor.js